export const isoDateRegex = /^(.*)([+-])(\d{2}):(\d{2})$/;
